import state from './state'
import actions from './actions'

const store = {
  state,
  actions
}

export default store
